import { COUNTRIES } from './countries';

export const COUNTRY_CURRENCIES = {
  Denmark: 'DKK',
  Sweden: 'SEK',
  Norway: 'NOK',
  Germany: 'EUR',
  Finland: 'EUR',
  China: 'CNY',
  India: 'INR',
  Poland: 'PLN',
  Vietnam: 'VND',
  Italy: 'EUR',
  Netherlands: 'EUR',
  Turkey: 'TRY',
  Other: 'Other',
};

export const CURRENCIES = [...new Set(COUNTRIES.map((country) => COUNTRY_CURRENCIES[country]))];
